import React from 'react';
import userCountry from 'js/services/UserCountry';
import { Link } from '@reach/router';

const BetterExperience = () => {
  return (
    <div className="step">
      <div className="mobile-screen">
        <img src="/images/v2/buyers/better-marketplace.png" alt="A better marketplace experience" className="d-none d-md-inline-block"/>
        <img src="/images/v2/buyers/market-experience-mobile.png" alt="A better marketplace experience" className="d-md-none"/>
      </div>
      <div className="step-content">
        <div className="d-md-flex align-items-md-center">
          <div>
            <h4>A better marketplace experience</h4>
            <p>
              When you’re buying on <strong>Facebook</strong>, <strong>Letgo</strong> and other buying apps,
              PayOnDelivery handles payment and shipping so you don’t have to
            </p>
            <img src="/images/v2/logos-selling-card.svg" alt="Marketplaces"/>
          </div>

          <div>
            <div className="green-square">
              Get $25 gift now to use on your purchases
            </div>

            <Link to={'/buyer-signup'} className="btn btn-pod btn-inverse btn-block d-none d-md-block">
              Start buying faster
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BetterExperience;
